var map = {
	"./FAQ_2025_de.pdf": 445,
	"./FAQ_2025_en.pdf": 5463,
	"./FAQ_2025_es.pdf": 521,
	"./FAQ_2025_fr.pdf": 3753,
	"./FAQ_2025_ms.pdf": 6391,
	"./FAQ_2025_pl.pdf": 9313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4924;